import {
  FETCH_BOOKSETS,
  UPDATE_BOOKSET,
  LOADING_BOOKSETS,
  REMOVE_BOOKSET,
  CLEAN_AUTH,
  SET_BOOKSET_RESULTS_TAB
} from "../actions/type";

const INIT_STATE = { booksetMap: {}, isLoadingBooksets: false, resultsActiveTab: 0 };

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case FETCH_BOOKSETS:
      return {
        ...state,
        booksetMap: { ...state.booksetMap, ...payload.booksetMap },
        isLoadingBooksets: false
      };

    case LOADING_BOOKSETS:
      return { ...state, isLoadingBooksets: true };

    case UPDATE_BOOKSET:
      return {
        ...state,
        booksetMap: {
          ...state.booksetMap,
          [payload.bookset._id]: payload.bookset
        }
      };

    case REMOVE_BOOKSET: {
      const { [payload.booksetId]: _removed, ...rest } = state.booksetMap;
      return { ...state, booksetMap: rest };
    }

    case SET_BOOKSET_RESULTS_TAB:
      return { ...state, resultsActiveTab: payload.activeTab };

    case CLEAN_AUTH:
      return { ...INIT_STATE };

    default:
      return state;
  }
};
